import { useEffect, useState } from "react";
import { subscribeBackendStatus } from "./backendStatus";

export function useBackendStatus() {
  const [backendDown, setBackendDown] = useState(false);

  useEffect(() => {
    return subscribeBackendStatus(setBackendDown);
  }, []);

  return { backendDown };
}